import { render } from "./edit-dialog.vue?vue&type=template&id=518aefd6&ts=true"
import script from "./edit-dialog.vue?vue&type=script&lang=ts"
export * from "./edit-dialog.vue?vue&type=script&lang=ts"

import "./edit-dialog.vue?vue&type=style&index=0&id=518aefd6&lang=scss"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__